import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { AuthorizationService } from '@app/services/authorization.service';

@Component({
    selector: 'app-admin-template',
    templateUrl: './admin-template.component.html',
    styleUrls: ['./admin-template.component.css'],
    standalone: false
})
export class AdminTemplateComponent implements OnInit {

  title = 'banking-app';
  isAdmin: boolean = false;
  isNavbarMinimized: boolean = true;

  constructor(public authenticationService: AuthenticationService,
    public authorizationService: AuthorizationService,
    private router: Router) { }

  ngOnInit(): void {
    if (!this.authenticationService.isAuthenticated()) {
      this.router.navigate(['/login']);
    }
    this.isAdmin = this.authorizationService.isAdmin();
  }

  toggleNavbar() {
    this.isNavbarMinimized = !this.isNavbarMinimized;
  }

}